// subscriptionHelper.js
import { regSw, subscribe } from './helper';

export async function registerAndSubscribe(username,total) {
  try {
    
    console.log("registerAndSubscribe",username,total);
    const serviceWorkerReg = await regSw();
    await subscribe(serviceWorkerReg,username,total);
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
}
